import React from 'react';
import PropTypes from 'prop-types';

const HeaderTitleRow = ({ icon, title, actions }) => {
  return (
    <div className="flex justify-between items-start border-b border-vamos-blue-gray pb-6 mb-5 mt-2.5">
      {/* Left: icon + title */}
      <div className="flex items-start gap-2.5">
        {icon}
        <h2 className="m-0 leading-tight font-bold text-vamos-black font-sans text-32">
          {title}
        </h2>
      </div>

      {/* Right: actions (e.g. buttons) */}
      <div className="flex items-start space-x-2 pl-4">
        {actions}
      </div>
    </div>
  );
};

HeaderTitleRow.propTypes = {
  icon: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  actions: PropTypes.element.isRequired,
};

export default HeaderTitleRow;
